import { Article, Section } from './styles';
import { Col, Row } from 'react-styled-flexboxgrid';

import BlogPosts from '@/components/BlogPosts';
import React from 'react';
import SectionHeadline from '@/components/ui/elements/SectionHeadline';

interface InsightProps {
  heading: string;
  bgColor?: string;
  posts: [];
}

const Insights: React.FC<InsightProps> = ({ heading, bgColor, posts }) => {
  return (
    <Section>
      <Article bgColor={bgColor}>
        <Row>
          <Col xs={12}>
            <header>
              <SectionHeadline>{heading}</SectionHeadline>
            </header>
            <BlogPosts posts={posts} />
          </Col>
        </Row>
      </Article>
    </Section>
  );
};

export default Insights;
